import { Typography, Space, Select, Button } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import useWindowSize from "../../../Shared/Utils/windowResizeUtils";
import MenuItem from "antd/es/menu/MenuItem";

const { Title } = Typography;

const CustomToolBar = (props) => {
   const windowSize$ = useSharedState();
    // console.log("test", windowSize$);
    const { width } = useWindowSize();
    const isMobile = width <= 768;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Title
          level={5}
          style={{ margin: "0 10px 0 0", cursor: "pointer" }}
          onClick={() => {
            props.onNavigate("TODAY");
            props.onView("month");
          }}
        >
          <CalendarOutlined style={{ marginRight: 8 }} />
          Today
        </Title>

        <Space>
          <LeftOutlined
            style={{ fontSize: 16, cursor: "pointer" }}
            onClick={() => props.onNavigate("PREV")}
          />
          <RightOutlined
            style={{ fontSize: 16, cursor: "pointer" }}
            onClick={() => props.onNavigate("NEXT")}
          />
        </Space>

        <span className="rbc-toolbar-label" style={{ marginLeft: 12 }}>
          {props.label}
        </span>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <Select
              // value={props.view}
              // onChange={handleView}
              placeholder="Select a state"
              style={{ width: isMobile ? 60 : 300 }}
            >
              <MenuItem value="month">Chicago</MenuItem>
              <MenuItem value="week">California</MenuItem>
              <MenuItem value="day">LA</MenuItem>
            </Select>
          </div>
          <div style={{ paddingLeft: "5px" }}>
            <Select
              // value={props.view}
              // onChange={handleView}
              placeholder="Select drug classes"
              style={{ width: isMobile ? 60 : 300 }}
            >
              <MenuItem value="month">Drug class1</MenuItem>
              <MenuItem value="week">Drug class2</MenuItem>
              <MenuItem value="day">Drug class3</MenuItem>
            </Select>
          </div>
          <div style={{ paddingLeft: "5px" }}>
            <Button type="primary">Clear</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomToolBar;
